import {TableNode} from '@table-library/react-table-library'
import {Theme} from '@table-library/react-table-library/types/theme'
import {DataTableColumnInfo} from '../model'

export function useDataTableDimensionsTheme<ColumnID extends string, ITEM extends TableNode>(columns: Array<DataTableColumnInfo<ColumnID, ITEM>>, height?: string): Theme {
  const totalWidth = columns.reduce((acc, column) => acc + column.fr, 0)
  const baseCellStyles = columns.reduce((acc, column) => {
    let newValue = acc + `&.${column.id} {
      width: ${column.fr / totalWidth * 100}%;
    `
    newValue += column.minWidth === undefined ? '' : `min-width: ${column.minWidth};`
    return newValue + '}'
  }, '')

  let tableStyles = `
    display: flex;
    flex-direction: column;
    position: relative;
  `
  tableStyles += height ? `height: ${height};` : ''

  return {
    Table: tableStyles,
    Body: `
      height: 100%;
    `,
    HeaderCell: `
      &.rowActions {
        visibility: hidden;
      }
    `,
    BaseCell: `
      & > div, &:first-of-type > div  {
        padding-right: 14px;
        padding-left: 14px;
      }
      &.selectCell:first-of-type > div {
        padding-right: 14px;
        padding-left: 14px;
      }
      &.selectCell ~ div > div {
         padding-left: 5px;
      }
      &.rowActions:last-of-type > div {
        padding-right: 5px;
        padding-left: 4px;
      }
      &.rowActions {
        display: flex;
        margin-left: auto;
        align-items: center;
        min-width: auto !important;
        width: auto !important;
        right: 0;
      }
      &.selectCell {
        flex-shrink: 0;
        min-width: 0;
        width: initial;
        padding: 0;
        left: 0px;
      }
      ${baseCellStyles}
    `,
  }
}